<template>
  <div class="coupon-desc-dialog">
    <el-dialog
      :visible.sync="visible"
      :title="coupon.scope === 1 ? '限以下国家使用' : '限以下商品可用'"
      :close-on-click-modal="false"
      top="50%"
      @close="closeModal">
      <div class="coupon-desc-body">
        <div class="tips-box">
          <div class="tips" v-if="coupon.scope === 2">注：特价商品不可用</div>
        </div>
        <div class="country-list" v-if="coupon.scope === 1">
          <div
            class="country-item"
            v-for="(item, index) in coupon.countries"
            :key="index"
            @click="gotoCountryPage(item)"
          >
            <img class="country-flag-img" :src="item.national_flag_img" alt="">
            <div class="country-name">{{item.country}}</div>
          </div>
        </div>
        <div class="product-list" v-else-if="coupon.scope === 2">
          <div
            class="coupon-product-item"
            v-for="(item, index) in coupon.products"
            :key="index"
          >
            <coupon-product-item
              :product="item"
            ></coupon-product-item>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CouponProductItem from './coupon-product-item.vue';

export default {
  name: 'common-dialog',
  components: {
    CouponProductItem,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: true,
    },
    coupon: Object,
  },
  computed: {
  },
  data() {
    return {
      visible: this.show,
    };
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
    },
  },
  methods: {
    // 关闭对话框回调
    closeModal() {
      this.visible = false;
    },
    gotoCountryPage(item) {
      const routeData = this.$router.resolve({ name: 'country', params: { id: item.id }, query: { from: 'coupon_desc' } });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>

.coupon-desc-dialog{
  /deep/ .el-dialog{
    width: 560px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -40%);
    .el-dialog__header{
      padding: 0 24px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border-bottom: 1px solid #E9EEF2;
      .el-dialog__title{
        font-size: 20px;
        color: #2F333D;
        font-weight: 600;
      }
      .el-dialog__headerbtn{
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        color: #91999F;
        &:hover{
          color: #599FFF;
        }
      }
    }
    .el-dialog__body{
      padding: 24px;
      color: #2F333D;
      font-size: 16px;
      line-height: 22px;
      background: #F3F6F9;
      max-height: 590px;
      overflow: auto;
      padding-top: 12px;
    }

    .el-dialog__footer{
      padding: 0;
    }
  }

  .coupon-desc-body{
    .tips-box{
      padding-bottom: 12px;
      .tips{
        color: #666;
        font-size: 14px;
        text-align: right;
        line-height: 1;
      }
    }
    .country-list{
      display: flex;
      flex-wrap: wrap;
      margin-right: -18px;
      margin-bottom: -18px;
      .country-item{
        width: 114px;
        height: 82px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #DEE2E6;
        flex-shrink: 0;
        margin-right: 18px;
        margin-bottom: 18px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 12px 12px;
        cursor: pointer;

        .country-flag-img{
          width: auto;
          height: 24px;
          border: 1px solid #DEE2E6;
        }
        .country-name{
          color: #2F333D;
          font-size: 18px;
          line-height: 26px;
          margin-top: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .product-list{
      .coupon-product-item{
        margin-bottom: 12px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/coupon-desc-dialog.vue